/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-08-13",
    versionChannel: "nightly",
    buildDate: "2023-08-13T00:23:15.804Z",
    commitHash: "3117469e20eeb1a435e678268252a4545228c030",
};
